import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import DownloadButton from "../download-button";
import {
  PLATFORM_CONFIG,
  PLATFORM_ORDER,
  type Platform,
} from "../../lib/downloads";
import styles from "./hero.module.css";
import { SonicWaveform } from "./sonic-waveform";

export function HeroSection() {
  const intl = useIntl();

  return (
    <section className={styles.heroSection} id="overview">
      <SonicWaveform />
      <div className={styles.heroOverlay} />
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>
          <FormattedMessage defaultMessage="Stop typing. Start talking." />
        </h1>
        <p className={styles.heroSubtitle}>
          <FormattedMessage defaultMessage="Vocally turns your voice into text — instantly, privately, on any app. Four times faster than typing." />
        </p>
        <div className={styles.heroActions}>
          <DownloadButton trackingId="download-hero" />
        </div>
        <div className={styles.heroMeta}>
          <p className={styles.heroNote}>
            <FormattedMessage defaultMessage="Free forever. No credit card needed." />
          </p>
          <div
            className={styles.heroPlatformList}
            aria-label={intl.formatMessage({
              defaultMessage: "Desktop downloads",
            })}
          >
            {PLATFORM_ORDER.map((platformId: Platform) => {
              const { Icon, name, id } = PLATFORM_CONFIG[platformId];
              return (
                <span
                  key={id}
                  className={styles.heroPlatformBadge}
                  role="img"
                  aria-label={name}
                  title={name}
                >
                  <Icon className={styles.heroPlatformIcon} size={24} />
                </span>
              );
            })}
          </div>
          <Link to="/download" className={styles.heroMoreLink}>
            <FormattedMessage defaultMessage="See all platforms" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
